const config = {
    api: {
        url: "http://localhost:3001"
    },
}

export default config;
